export default {
  name: 'dashify:Events',
  title: 'Events',
  owner: 'System',
  solution: '',
  tags: ['html'],
  createdAt: 'May 30, 2023, 10:14 AM',
  updatedAt: 'May 31, 2023, 11:14 AM',
  spec: {
    test: 'test',
    view: [
      [
        'button',
        {
          '.': 'btn btn-primary',
          onClick: '/${ function($e){ $emits("click", $e)} }',
        },
        'Click Me',
      ],
    ],
  },
};
